import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { MentoringProgramEnrollment } from 'redux/schemas/models/mentoring-program-enrollments';

type MentoringProgramParams = {
  programId: number;
};

export type MentorQuestionAnswerFilter = {
  question_id: number;
  answers: string[];
};

type SearchMentorsParams = MentoringProgramParams & {
  searchTerm?: string;
  filters?: MentorQuestionAnswerFilter[];
  page: number;
  pageSize: number;
};

export type SearchMentorsResult = {
  totalCount: number;
  mentors: MentorResult[];
}

export type MentorResult = Pick<MentoringProgramEnrollment, 'id' | 'role' | 'user'> & {
  user: MentoringProgramEnrollment['user'] & {
    bio: string;
    headline: string;
  },
  availability: number;
  connectionRequested: boolean;
};

export const searchMentors = createAsyncThunk<
  MentorResult[],
  SearchMentorsParams
>(
  'SEARCH_PARTICIPANT_DRIVEN_MENTORS',
  async ({ programId, searchTerm = '', filters = [], page, pageSize }, thunkAPI) => {
    const response = await axios.post(
      `/mentorship_programs/${programId}/search_mentors`,
      {
        query: {
          search_term: searchTerm,
          mentor_question_answers: filters,
        },
        availability_desc: true,
        last_visit_date_desc: true,
        requested_desc: true,
        page,
        page_size: pageSize,
      }
    );
    const { totalCount, mentors } = response.data.result;
    thunkAPI.dispatch(setSearchMentorsResultTotalCount({ totalCount }));
    return mentors as MentorResult[];
  }
);

export type MentorQuestionAnswer = {
  id: number;
  questionText: string;
  searchableAnswers: string[];
};

export const getMentorsQuestionAnswers = createAsyncThunk<
  MentorQuestionAnswer[],
  MentoringProgramParams
>('GET_PARTICIPANT_DRIVEN_MENTORS_QUESTION_ANSWERS', async ({ programId }) => {
  const response = await axios.get(
    `/mentorship_programs/${programId}/mentors_question_answers.json`
  );
  return response.data.result as MentorQuestionAnswer[];
});

export const setSearchMentorsResultTotalCount = createAction<{
  totalCount: number;
}>('SET_SEARCH_MENTORS_RESULT_TOTAL_COUNT');

export const clearLastMentorsSearchAndFilters = createAction('CLEAR_LAST_MENTORS_SEARCH_AND_FILTERS');
